import { z } from 'zod';

export const TableDepositValueCostSchema = z.object({ currency: z.string(), amount: z.number() });

export const TableDepositValueSchema = z.object({
  _type: z.literal('CalculatedTableDeposit'),
  date: z.string(),
  cost: TableDepositValueCostSchema,
  unitCost: TableDepositValueCostSchema,
  depositType: z.union([z.literal('booking'), z.literal('cover')]),
  description: z.string().optional().nullable(),
  guestCount: z.number(),
});
